<div class="adtabcontent">
<app-column-header [headerData]="headerData" (topbtnaction)="onSubmit()"></app-column-header>
<form [formGroup]="createDashboardForm" (ngSubmit)="onSubmit()">
  <div class="admintabfields">
    <!-- <div class="row"> -->
      <div class="filedgrid thrcol">

        <div class="colbox" *ngIf="appTemplateList.length>0">
          <label class="control-label">Template<span>*</span></label>
          <ng-select class="formgroup" formControlName="templateId" [items]="appTemplateList"
            placeholder="Select template" bindLabel="templateName" bindValue="templateId"></ng-select>

        </div>
        <div class="colbox">
          <label class="control-label">DashBoard Type<span>*</span></label>
          <ng-select class="formgroup" formControlName="DashBoardid" (change)="Bindmodulepage()"
            [items]="Dashboardtype" placeholder="Select Dashboard type" bindLabel="name" bindValue="id"></ng-select>

        </div>
        <div class="colbox" *ngIf="menuListdata.length>0">
          <label class="control-label">Module<span>*</span></label>
          <ng-select class="formgroup" formControlName="moduleId" [items]="menuListdata" placeholder="Select module"
            bindLabel="gstibo_menu_name" bindValue="gstibo_menu_id"></ng-select>

        </div>
        
        
        <!-- <div class="formGroup"></div>
        <div class="formGroup"></div>
        <div class="formGroup"></div>
        <div class="formGroup"></div>
        <div class="formGroup"></div>
        <div class="formGroup"></div> -->


      </div>
      <div class="filedgrid thrcol">
        <div class="colbox" *ngIf="pageListData.length>0">
          <label class="control-label">Pages<span>*</span></label>
          <ng-select class="formgroup" formControlName="pageId" [items]="pageListData" placeholder="Select page"
            bindLabel="gstibo_page_name" bindValue="gstibo_page_id"></ng-select>

        </div>
      </div>
    <!-- </div> -->
    <!-- <div class="row"></div> -->
  </div>
</form>
</div>